import { render, staticRenderFns } from "./SchemaList.vue?vue&type=template&id=59f93ead"
import script from "./SchemaList.vue?vue&type=script&lang=js"
export * from "./SchemaList.vue?vue&type=script&lang=js"
import style0 from "./SchemaList.vue?vue&type=style&index=0&id=59f93ead&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports